module.exports = __webpack_public_path__ + "static/media/slack-new-logo.48a3232b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/webportal/theme/images/slack-new-logo.svg
// module id = 754
// module chunks = 1